module.exports = __webpack_public_path__ + "media/images/spinner/Spinner-1s-90px-2202e4b09c982200e2f3b2496f0697e9.gif";